

const state = {
    
    blocks:[
        {
            id:1,
            name: 'Adressdaten',
            color: '#fff',   
            columns:1,
            blockcomponents: {
                columns: [
                    //left Column
                    [
                        {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Adressen auswählen",
                                size:"xs10",
                                invertedsize:"xs1",
                                displaytitle:"street",
                                displaysubtitle:"zip",
                                multiple:false,
                                icon:"search",
                                variable: 'adress_id',
                                setter: 'companies/COMPANY_SET_ADRESS',                                    
                                items:'adresses/adresses',
                                withdialog:true,
                            }                                    
                        }
                    ],                   
                ]
            },
        },
        {
            id:2,
            name: 'Tochterkonzerne',
            color: '#fff',    
            blockcomponents: {
                columns: [
                    [
                        {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Tochterkonzern auswählen",
                                size:"xs10",
                                invertedsize:"xs1",
                                displaytitle:"name",
                                displaysubtitle:"id",
                                multiple:true,
                                icon:"search",
                                variable: 'children_ids',
                                setter: 'companies/COMPANY_SET_CHILDREN',
                                items:'companies/companies',
                                withdialog:false,
                            }                                    
                        }
                    ]
                ]
            }
        }
    ]
    
};

export default {
  namespaced: false,
  state,
  
};